import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, FormControlLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, RadioGroup, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'
import { Add, Close } from '@material-ui/icons'

import { TextField } from '@material-ui/core'
import { observer } from 'mobx-react'
import useStore from 'store'
import Users from 'assets/icons/Users.svg'
import EmergencyIcon2 from 'assets/icons/ims/Emergency2.svg'

import Search from 'assets/icons/Search.svg'
import Health from 'assets/icons/ims/Health.svg'
import Health2  from 'assets/icons/ims/Health2.svg'
import Music from 'assets/icons/ims/Music.svg'
import School from 'assets/icons/ims/School.svg'
import Help from 'assets/icons/ims/Help.svg'
import Help2 from 'assets/icons/Help2.svg'


import EmergencyIcon from 'assets/icons/ims/Emergency.svg'
import { getTagError, TAG_MAX_LENGTH } from 'utils/tagRules'
const Section = styled.div`
  display: flex;
  padding: 1px;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid rgba(226, 232, 240, 0.50);
  background: rgba(241, 245, 249, 0.20);
`
const DetailsHeader = styled.div`
  display: flex;
  width: 100%;
  height: 55.98px;
  padding: 16.722px 21.326px 15.259px 0px;
  justify-content: flex-start;
  align-items: center;
  color: #0F172A;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const DetailsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 7.997px 20px 20px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.991px;
`
const DetailsSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const DetailsTitle1 = styled.div` 
  display: flex;
  width: 100%; 
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`
const DetailsTitle2 = styled.div`
  color: #64748B;
  text-align: right;
  width: 100%;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const DatailsNewRoleContainer = styled.div`
  display: flex;
  padding: 0 0 0 0.19px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-endstart;
  gap: 11.995px;
  align-self: stretch;
`
const RoleList = styled.div`
  display: flex;
  justify-content: flex-start;  
  align-items: center;
  gap: 8px;
   flex-wrap: wrap;
`
const TAG_COLORS = [
  { color: '#EA580C', border: '#EA580C' },
  { color: '#0284C7', border: '#0284C7' },
  { color: '#16A34A', border: '#16A34A' },
  { color: '#9333EA', border: '#9333EA' },
  { color: '#DC2626', border: '#DC2626' },
  { color: '#0891B2', border: '#0891B2' },
  { color: '#CA8A04', border: '#CA8A04' },
  { color: '#BE185D', border: '#BE185D' },
]

const getTagColor = (name: string) => {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length]
}

const TagButton = styled(Button)<{ tagcolor: string; tagborder: string }>`
  display: flex;
  padding: 5px 13px;
  align-items: center;
  gap: 3px;
  border-radius: 30504000px;
  border: 0.909px solid ${p => p.tagborder};
  color: ${p => p.tagcolor};
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const NewTagButton = styled(Button)`
  display: flex;
  padding: 5px 13px;
  align-items: center;
  gap: 3px;
  border-radius: 30504000px;
  border: 0.909px dashed #64748B;
  color: #64748B;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const RoleButton = styled(Button)`
  display: flex;
  padding: 5px 13px;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  border: 0.909px solid #A3B3FF;
  color: #432DD7;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`
const NewRoleButton = styled(Button)`
  display: flex;
  padding: 5px 13px;
  align-items: center;
  gap: 4px;
  border-style: dashed;
  border-radius: 6px;
  border: 0.909px dashed #64748B;
  color: #64748B; 
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

const DetailsCheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const SearchContainer = styled.div` 
  display: flex;
  height: 41.804px;
  padding: 0px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
const SearchInput = styled(TextField)`
  display: flex;
  width: 100%;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
  align-items: center;
  color: rgba(15, 23, 42, 0.50);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .MuiOutlinedInput-root {
    padding: 0px;
    width 100%;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0px;
  }
`
const DetailsCheckboxContainer = styled.div`
  display: flex;
  padding: 9px 10px;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.05);
`
const DetailsCheckboxListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`
const DetailsCheckboxListColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
   width: 100%;
  gap: 7.997px;
`
const DetailsCheckboxListItem = styled.div`
  display: flex;
  width: 100%;
  height: 42px;
  padding: 0 10px;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.10);
`
const DetailsCheckbox = styled(Checkbox)`
  width: 16px;
  height: 16px;
`
const DetailsImage = styled(Image)`
 display: flex;
width: 20px;
height: 20px;
flex-direction: column;
align-items: flex-start;
`                                    
const DetailsItemTitle = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const DetailsRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
  padding-bottom: 20px;
`
const DetailsRadioHeader = styled.div` 
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
  color: #64748B;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`
const DetailsRadioSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const DetailsRadioSubContent = styled.div <{ bg: string, borderColor: string }>`
  display: flex;
  height: 69.787px;
  padding: 12.898px 12.898px 0.909px 12.898px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid ${p => p.borderColor};
  background: ${p => p.bg};
`
const DetailsRationHeaderItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #1C398E;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const DetailsRationContainerItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`
const DetailsRationItem = styled.div`
  display: flex;
  height: 15.994px;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  color: #0F172A; 
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
const DetailsRadio = styled(Radio)`
  width: 16px;
  height: 16px;
`
// Name plus save and cancel. It was stretched across the dialog, so typing a
// two-word tag name happened in a box the width of the screen.
const NewContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 520px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 7.997px;
  flex-shrink: 0;
`
const NewSaveButton = styled(Button)`
  display: flex;
  padding: 9.634px 15.943px 8.17px 15.994px;
  justify-content: center;
  align-items: center;
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 6px;
  background: #2563EB;
`
const NewCancelButton = styled(Button)`
  display: flex;
  padding: 9.634px 15.074px 8.17px 15.994px;
  justify-content: center;
  align-items: center;
  color: #0F172A;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  border-radius: 6px;
  background: #F1F5F9;
  line-height: 24px;
`
const NewInput = styled(TextField)`
  display: flex;
  height: 41.804px;
  padding: 0px;
  justify-content: flex-end;
  align-items: center;
  flex: 1 0 0;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
  color: rgba(15, 23, 42, 0.50);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .MuiOutlinedInput-root {
    height: 41.804px;
    padding: 0px;
    width 100%;
  }
  .MuiOutlinedInput-notchedOutline{
    height: 41.804px;
    border: 0px;
  }
`
const RoleListSelected = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`
const SelectedRoleButton = styled(Button)`
  display: flex;
  padding: 5px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  border: 0.909px solid rgba(37, 99, 235, 0.25);
  background: rgba(37, 99, 235, 0.06);
  color: #432DD7;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const SelectedTagButton = styled(Button)<{ tagcolor: string; tagborder: string }>`
  display: flex;
  padding: 5px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 30504000px;
  border: 0.909px solid ${p => p.tagborder}40;
  background: ${p => p.tagcolor}10;
  color: ${p => p.tagcolor};
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
export type RoleTag = { tagName: string; tagTypeId: number; action?: 'new' }
export type OtherTag = { tagName: string; tagTypeId: number; action?: 'new' }

export type ContactInfoData = {
  roles: RoleTag[]
  tags: OtherTag[]
  groups: string[]
  permissions: {
    [system: string]: 'no_access' | 'user' | 'editor' | 'management' | 'admin' | 'superadmin'
  }
}

type Props = {
  value: ContactInfoData
  onChange: (value: ContactInfoData) => void,
  disableEdit: boolean,
  tags: { data: any[] },
  tagTypes: any[],
}

const ContactInfoSection: FC<Props> = ({ value, onChange, disableEdit, tags, tagTypes }) => {
  const { members, orgs, uiStore, memberStore } = useStore()
  const { t } = useTranslation('members')

  const selectedRoles = value.roles
  const selectedTags = value.tags

  const update = (patch: Partial<ContactInfoData>) => {
  onChange({
    ...value,
    ...patch,
  })}

  const addRoleToList = (tag: RoleTag) => {
    if (selectedRoles.some(r => r.tagName === tag.tagName)) return
    update({ roles: [...selectedRoles, tag] })
  }

  const removeRoleFromList = (tagName: string) => {
    update({ roles: selectedRoles.filter(r => r.tagName !== tagName) })
  }

  const addTagToList = (tag: OtherTag) => {
    if (selectedTags.some(t => t.tagName === tag.tagName)) return
    update({ tags: [...selectedTags, tag] })
  }

  const removeTagFromList = (tagName: string) => {
    update({ tags: selectedTags.filter(t => t.tagName !== tagName) })
  }

  const [openNewRoleForm, setOpenNewRoleForm] = useState(false)
  const [openNewTagForm, setOpenNewTagForm] = useState(false)
  const [newRoleName, setNewRoleName] = useState('')
  const [newTagName, setNewTagName] = useState('')
  const newRoleError = getTagError(newRoleName)
  const newTagError = getTagError(newTagName)

  return (
    <Section>
      <DetailsHeader>{t`population:details_header`}</DetailsHeader>
                        <DetailsContainer>
                            <DetailsSubContainer>
                                <DetailsTitle1>{t`population:roles`}</DetailsTitle1>
                                <DatailsNewRoleContainer>
                                    {!openNewRoleForm &&
                                    <>
                                        {selectedRoles.length == 0 && <DetailsTitle2>{t`population:click_to_add_role`}</DetailsTitle2>}
                                         
                                          <>
                                            <RoleListSelected>
                                              {selectedRoles.map((role) => <SelectedRoleButton key={role.tagName} onClick={() => { if (!disableEdit) removeRoleFromList(role.tagName) }} endIcon={!disableEdit && <Close />}>{role.tagName}</SelectedRoleButton>)}
                                            </RoleListSelected>
                                            {!disableEdit &&
                                            <RoleList>
                                              {tags.data.filter(tag => tag.tagType === 'role' && !selectedRoles.some(r => r.tagName === tag.tagName)).map(tag => <RoleButton key={tag.tagName} onClick={() => addRoleToList({ tagName: tag.tagName, tagTypeId: tagTypes.find(t => t.typeName === 'role')?.id })} startIcon={<Add />}>{tag.tagName}</RoleButton>)}
                                              {<NewRoleButton onClick={() => setOpenNewRoleForm(true)} startIcon={<Add />}>{t`population:new_role`}</NewRoleButton>}
                                            </RoleList>}
                                          </>  
                                        
                                    </>}

                                    {openNewRoleForm &&
                                      <NewContainer>
                                        <NewInput
                                          placeholder={t`population:new_role_placeholder`}
                                          variant="outlined"
                                          value={newRoleName}
                                          onChange={e => setNewRoleName(e.target.value)}
                                          error={!!newRoleError}
                                          helperText={newRoleError && t(`population:${newRoleError}`, { max: TAG_MAX_LENGTH })}
                                        />
                                        <NewSaveButton disabled={!!newRoleError} onClick={() => {
                                          const trimmed = newRoleName.trim()
                                          if (!trimmed) return
                                          if (tags.data.some(tag => tag.tagType === 'role' && tag.tagName === trimmed)) return
                                          addRoleToList({ tagName: trimmed, tagTypeId: tagTypes.find(t => t.typeName === 'role')?.id, action: 'new' })
                                          setNewRoleName('')
                                          setOpenNewRoleForm(false)
                                        }}>{t`population:add`}</NewSaveButton>
                                        <NewCancelButton onClick={() => { setNewRoleName(''); setOpenNewRoleForm(false) }}>{t`population:cancel`}</NewCancelButton>
                                      </NewContainer>}
                                </DatailsNewRoleContainer>
                            </DetailsSubContainer>
                            <DetailsSubContainer>
                                <DetailsTitle1>{t`population:more_tags`}</DetailsTitle1>
                                <DatailsNewRoleContainer>
                                    {!openNewTagForm &&
                                    <>
                                      {selectedTags.length == 0 && <DetailsTitle2>{t`population:click_to_add_tag`}</DetailsTitle2>}
                                        
                                        <>
                                          <RoleListSelected>
                                            {selectedTags.map((tag) => { const tc = getTagColor(tag.tagName); return <SelectedTagButton key={tag.tagName} tagcolor={tc.color} tagborder={tc.border} onClick={() => { if (!disableEdit) removeTagFromList(tag.tagName)}} endIcon={!disableEdit && <Close />}>{tag.tagName}</SelectedTagButton> })}
                                          </RoleListSelected>
                                          {!disableEdit && 
                                          <RoleList>
                                            {tags.data.filter(tag => tag.tagType === 'others' && !selectedTags.some(t => t.tagName === tag.tagName)).map(tag => { const tc = getTagColor(tag.tagName); return <TagButton key={tag.tagName} tagcolor={tc.color} tagborder={tc.border} onClick={() => addTagToList({ tagName: tag.tagName, tagTypeId: tagTypes.find(t => t.typeName === 'others')?.id })} startIcon={<Add />}>{tag.tagName}</TagButton> })}
                                            <NewTagButton onClick={() => setOpenNewTagForm(true)} startIcon={<Add />}>{t`population:new_tag`}</NewTagButton>
                                          </RoleList>}
                                        </>
                                    </>
                                    }

                                     {openNewTagForm &&
                                      <NewContainer>
                                        <NewInput
                                          placeholder={t`population:new_tag_placeholder`}
                                          variant="outlined"
                                          value={newTagName}
                                          onChange={e => setNewTagName(e.target.value)}
                                          error={!!newTagError}
                                          helperText={newTagError && t(`population:${newTagError}`, { max: TAG_MAX_LENGTH })}
                                        />
                                        <NewSaveButton disabled={!!newTagError} onClick={() => {
                                          const trimmed = newTagName.trim()
                                          if (!trimmed) return
                                          if (tags.data.some(tag => tag.tagType === 'others' && tag.tagName === trimmed)) return
                                          addTagToList({ tagName: trimmed, tagTypeId: tagTypes.find(t => t.typeName === 'others')?.id, action: 'new' })
                                          setNewTagName('')
                                          setOpenNewTagForm(false)
                                        }}>{t`population:add`}</NewSaveButton>
                                        <NewCancelButton onClick={() => { setNewTagName(''); setOpenNewTagForm(false) }}>{t`population:cancel`}</NewCancelButton>
                                      </NewContainer>}
                                </DatailsNewRoleContainer>
                            </DetailsSubContainer>
    
                        </DetailsContainer>
                      </Section>                  
  )
}

export default observer(ContactInfoSection)


